
import { SubDomain } from "../SubDomain.js";
import Payment from "./Payment.js";

export default class PaymentsDomain extends SubDomain {
  
  constructor(domain, storage) {
    super(domain, Payment.MODEL_NAME);
    this._storage = storage;
  }
  
  list() {
    return this._storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new Payment(this.domain, item);
      }
    }

    return new Payment(this.domain);
  }
  
}